<template>
  <breeze-authenticated-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Organizations
      </h2>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
          <div class="p-6 bg-white border-b border-gray-200">
            <organizations />
          </div>
        </div>
      </div>
    </div>
    <div class="custom-privacy">
      <a
        href="https://sites.google.com/nuvita.com/corsyncpublicpages/privacy-policy"
        target="_blank"
        >Privacy Policy</a
      >
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import Organizations from '@/Components/Organizations/organization-listing'

export default {
  components: {
    BreezeAuthenticatedLayout,
    Organizations,
  },
}
</script>
<style lang="scss" scoped>
.custom-privacy {
  position: fixed;
  bottom: 10px;
  left: 10px;
}
</style>
